import React, { Component } from "react";
import questions from "./qnaJSONdata/QnAAngular.json";
import QnASideBarRight from "./QnASideBarRight";
import ScrollButton from "../../ScrollButton";

class QnAAngular extends Component {
  render() {
    return (
      <div className="container-fluid">
        <div className="row flex-xl-nowrap">
          <div className="col-6 col-md-2 clo-xl-2 bd-sidebar mb-2 m4"></div>
          <main
            className="col-12 col-md-9 col-xl-8 py-md-3 pl-md-5 bd-content"
            role="main"
          >
            <div className="col-xs-12">
              <h2 className="m-5">Angular Interview Questions</h2>
              <p className="text-left lead text-justify text-break">
                {" "}
                Angular is a popular open-source framework for building dynamic
                web applications. It was developed by Google and is written in
                TypeScript. Angular allows developers to build applications that
                are scalable, fast, and maintainable.
              </p>
              <p className="text-left lead text-justify text-break">
                The framework uses a component-based architecture that makes it
                easy to build reusable UI components and manage the flow of data
                in the application. Angular also includes features such as
                two-way data binding, which allows changes in the UI to
                immediately reflect the underlying data model and vice versa.
              </p>
              <p className="text-left lead text-justify text-break">
                Angular has a large and active community, which has produced
                many libraries and tools that can be easily integrated into
                Angular applications. The framework also has a powerful CLI tool
                that makes it easy to generate, build, and deploy Angular
                applications.
              </p>
              <p className="text-left lead text-justify text-break">
                Another advantage of Angular is its performance. The framework
                uses change detection and lazy-loading techniques to ensure that
                only the necessary parts of the application are loaded and
                rendered, resulting in fast and responsive applications.
              </p>
              <p className="text-left lead text-justify text-break">
                Overall, Angular is a versatile framework that can be used to
                build a wide range of applications, from simple single-page
                applications to complex enterprise-level applications. Its
                component-based architecture, performance optimizations, and
                active community make it an attractive choice for developers
                looking to build dynamic and maintainable web applications.
              </p>
              <p className="text-left lead text-justify text-break">
                The most popular Angular interview questions are as follows:
              </p>
              <p className="text-left lead text-justify text-break">
                <ol>
                  {questions.map(question => (
                    <li key={question.id}>
                      <h5>{question.question}</h5>
                      <div>
                        <p>{question.answer}</p>
                      </div>
                    </li>
                  ))}
                </ol>
              </p>
            </div>
          </main>
          <div className="col-6 col-md-2 clo-xl-2 mb-2 border-left">
            <QnASideBarRight />
          </div>
        </div>
        <ScrollButton />
      </div>
    );
  }
}

export default QnAAngular;
